//
// epics-routing.js
//
// Copyright (c) 2015 by Curalate, Inc.
//

/* global angular: false */

((() => {
    angular.module('curalate').config(['$routeProvider', '$locationProvider',
        ($routeProvider, $locationProvider) => {
            $locationProvider.html5Mode({
                enabled: true,
                requireBase: false,
            }).hashPrefix('!');
            $routeProvider.
                when('/v1/features/', {
                    templateUrl: '/templates/features/features.html',
                    controller: 'FeaturesController',
                }).
                otherwise({
                    redirectTo: '/v1/features/',
                });
        },
    ]);
}))();
